import {Component, OnInit} from "@angular/core";
import {JwksValidationHandler, OAuthService} from "angular-oauth2-oidc";
import {ActivatedRoute} from "@angular/router";
import {authConfig} from "./auth-config";

@Component({
  template: ''
})


export class LogoutComponent implements OnInit {
  constructor(private oauthService: OAuthService,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    const returnUrlParam = this.activatedRoute.snapshot.queryParams['returnUrl'];
    if (returnUrlParam) {
      localStorage.setItem('returnUrl', returnUrlParam)
    }
    let returnUrl = returnUrlParam || localStorage.getItem('returnUrl');
    if (!this.oauthService.getIdToken() && returnUrl) {
      window.location.href = returnUrl;
    } else {
      this.oauthService.configure(authConfig);
      this.oauthService.tokenValidationHandler = new JwksValidationHandler();
      this.oauthService.logOut();
    }
  }

}
